import { IECSClientOptions } from '@ms-ofb/floodgate-shared-typings';
import packageJson from '../../package.json';

// These default filters will be changed when Self-Serve is ready
// with Floodgate ECS client.
const filters = new Map<string, string | number>();
filters.set('disableexperiments', 'true');
filters.set('disablerollouts', 'false');

const DefaultFloodgateECSOptions: IECSClientOptions = {
	host: 'https://config.edge.skype.com',
	clientName: 'CHILL',
	clientVersion: packageJson.version,
	timeout: 60000,
	allowBackgroundFetch: true,
	filters
}

export default DefaultFloodgateECSOptions;
